import { actions } from './actions';
import { mutations } from './mutations';
var state = {
    password: null,
    passwordConfirmation: null,
    invite: null,
    authOptions: null,
};
export var userSetup = {
    namespaced: true,
    state: state,
    actions: actions,
    mutations: mutations,
};
